import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'news';

export const NEWS_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export const slugify = (value) =>
  (value || '')
    .toString()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);

export const isSlugTaken = async (slug, exceptId = null) => {
  if (!slug) return false;
  const q = query(collection(db, COLLECTION), where('slug', '==', slug), limit(2));
  const snap = await getDocs(q);
  return snap.docs.some((d) => d.id !== exceptId);
};

export const createNews = async ({ authorId, title = '', slug = '', blocks = [] }) => {
  const ref = await addDoc(collection(db, COLLECTION), {
    title,
    slug,
    blocks,
    status: NEWS_STATUS.DRAFT,
    authorId,
    coverImage: null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    publishedAt: null,
  });
  return ref.id;
};

export const updateNews = async (id, patch) => {
  await updateDoc(doc(db, COLLECTION, id), {
    ...patch,
    updatedAt: serverTimestamp(),
  });
};

export const publishNews = async (id) => {
  await updateDoc(doc(db, COLLECTION, id), {
    status: NEWS_STATUS.PUBLISHED,
    publishedAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
};

export const unpublishNews = async (id) => {
  await updateDoc(doc(db, COLLECTION, id), {
    status: NEWS_STATUS.DRAFT,
    updatedAt: serverTimestamp(),
  });
};

export const deleteNews = async (id) => {
  await deleteDoc(doc(db, COLLECTION, id));
};

export const getNews = async (id) => {
  const snap = await getDoc(doc(db, COLLECTION, id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};

export const getNewsBySlug = async (slug) => {
  const q = query(collection(db, COLLECTION), where('slug', '==', slug), limit(1));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
};

export const listenAllNews = (cb) => {
  const q = query(collection(db, COLLECTION), orderBy('updatedAt', 'desc'));
  return onSnapshot(q, (snap) => {
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

export const listenPublishedNews = (cb) => {
  const q = query(
    collection(db, COLLECTION),
    where('status', '==', NEWS_STATUS.PUBLISHED),
    orderBy('publishedAt', 'desc')
  );
  return onSnapshot(q, (snap) => {
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

export const BLOCK_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
};

export const makeTextBlock = (html = '') => ({
  id: crypto.randomUUID(),
  type: BLOCK_TYPES.TEXT,
  html,
});

export const makeImageBlock = ({ url = '', storagePath = '', alt = '', caption = '' } = {}) => ({
  id: crypto.randomUUID(),
  type: BLOCK_TYPES.IMAGE,
  url,
  storagePath,
  alt,
  caption,
});
